/* UT · Menú móvil por niveles. Paneles deslizantes con historial (volver) y reset al cerrar. */
(() => {
  if (customElements.get('ut-menu-mobile')) return;
  class UtMenuMobile extends HTMLElement {
    connectedCallback() {
      this.drawer = this.closest('.menu-drawer');
      this.details = this.closest('details');
      this.stack = ['ut-mm-root'];
      this.addEventListener('click', this.onClick);
      this.addEventListener('keyup', this.onKey);
      if (this.details) {
        this.mo = new MutationObserver(() => {
          const open = this.details.hasAttribute('open');
          document.documentElement.classList.toggle('ut-mm-open', open);
          if (!open) this.reset();
        });
        this.mo.observe(this.details, { attributes: true, attributeFilter: ['open'] });
      }
    }
    disconnectedCallback() { this.mo?.disconnect(); }
    panel(id) { return this.querySelector('#' + CSS.escape(id)); }
    onClick = (e) => {
      const open = e.target.closest('[data-ut-open]');
      if (open) { e.preventDefault(); this.go(open.dataset.utOpen, open); return; }
      if (e.target.closest('[data-ut-back]')) { e.preventDefault(); this.back(); return; }
      if (e.target.closest('[data-ut-close]')) { e.preventDefault(); this.closeDrawer(); }
    };
    onKey = (e) => {
      if (e.key === 'Escape' && this.stack.length > 1) { e.stopPropagation(); this.back(); }
    };
    go(id, trigger) {
      const next = this.panel(id); const cur = this.panel(this.stack.at(-1));
      if (!next || next === cur) return;
      next.hidden = false; next.scrollTop = 0;
      void next.offsetWidth; // reflow para que la transición arranque
      cur?.classList.add('is-behind'); cur?.classList.remove('is-active');
      cur?.setAttribute('aria-hidden', 'true');
      next.classList.add('is-active'); next.removeAttribute('aria-hidden');
      trigger?.setAttribute('aria-expanded', 'true');
      this.stack.push(id);
      this.drawer?.classList.add('ut-mm--sub');
      setTimeout(() => next.querySelector('[data-ut-back]')?.focus({ preventScroll: true }), 300);
    }
    back() {
      if (this.stack.length < 2) return;
      const curId = this.stack.pop(); const cur = this.panel(curId); const prev = this.panel(this.stack.at(-1));
      cur.classList.remove('is-active'); cur.setAttribute('aria-hidden', 'true');
      prev.classList.remove('is-behind'); prev.classList.add('is-active'); prev.removeAttribute('aria-hidden');
      setTimeout(() => { if (!cur.classList.contains('is-active')) cur.hidden = true; }, 320);
      const trig = prev.querySelector(`[data-ut-open="${curId}"]`);
      trig?.setAttribute('aria-expanded', 'false');
      trig?.focus({ preventScroll: true });
      if (this.stack.length === 1) this.drawer?.classList.remove('ut-mm--sub');
    }
    reset() {
      this.stack = ['ut-mm-root'];
      this.querySelectorAll('[data-ut-panel]').forEach((p) => {
        const root = p.id === 'ut-mm-root';
        p.classList.toggle('is-active', root); p.classList.remove('is-behind');
        p.hidden = !root; if (root) { p.removeAttribute('aria-hidden'); p.scrollTop = 0; }
      });
      this.querySelectorAll('[data-ut-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      this.drawer?.classList.remove('ut-mm--sub');
    }
    closeDrawer() {
      const hd = this.closest('header-drawer');
      if (hd && typeof hd.close === 'function') hd.close();
      else this.details?.removeAttribute('open');
    }
  }
  customElements.define('ut-menu-mobile', UtMenuMobile);
})();
